import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api";

const statusClass = { pending: "badge-yellow", payable: "badge-blue", paid: "badge-green", cancelled: "badge-gray" };

export default function Conversions() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  useEffect(() => { api.get("/conversions").then((res) => setItems(res.data)).finally(() => setLoading(false)); }, []);
  return (
    <div data-testid="conversions-page">
      <header className="page-head"><h1>Conversions</h1></header>
      {loading ? <div className="loading">Loading…</div> : items.length === 0 ? (
        <div className="empty" data-testid="conversions-empty">No conversions yet. They will appear here once Shopify orders are received.</div>
      ) : (
        <div className="table-wrap"><table data-testid="conversions-table">
          <thead><tr><th>Shopify Order</th><th>Date</th><th>Affiliate</th><th>Original Commission</th><th>Adjustments</th><th>Net Commission</th><th>Currency</th><th>Order Status</th><th>Maturity</th><th>Payment</th></tr></thead>
          <tbody>{items.map((conversion) => (
            <tr key={conversion.id} className="clickable" data-testid={`conversion-row-${conversion.id}`} onClick={() => navigate(`/conversions/${conversion.id}`)}>
              <td>{conversion.shopifyOrderName || conversion.shopifyOrderId}</td>
              <td>{conversion.orderCreatedAt ? new Date(conversion.orderCreatedAt).toLocaleDateString() : "—"}</td>
              <td>{conversion.affiliateName || conversion.affiliateCode || "—"}</td>
              <td>{conversion.originalCommissionAmount ?? "—"}</td><td>{conversion.adjustmentTotal ?? "—"}</td><td>{conversion.netCommissionAmount ?? "—"}</td><td>{conversion.currency || "—"}</td>
              <td><span className={`badge ${statusClass[conversion.orderStatus] || "badge-gray"}`}>{conversion.orderStatus}</span></td><td>{conversion.maturityStatus}</td><td>{conversion.paymentStatus}</td>
            </tr>
          ))}</tbody>
        </table></div>
      )}
    </div>
  );
}
